module.exports = __webpack_public_path__ + "static/media/preservacao-thumbnail.f1f49416.webp";